/*
 * 柴发带载测点数据（公共）：自动取数看板 + 历史记录 / 人工记录卡片
 * 柴发月度检查清单（middle_dg 3.7）与柴发并机测试（parallel_dg）共用
 * 记录格式与后端一致：{ log_time, WorkTime, UabKv, UbcKv, UcaKv, Ia, Ib, Ic, Pf, S, P, Q, F, RotateRate, OilPress, CoolantTemp }
 * 依赖：core.js ui.js
 */
export default function installPoints(MW) {
  var h = MW.h, ui = MW.ui, util = MW.util, store = MW.store;

  /** 带载数据测点（form1 / form2 为自动获取的只读表，card1 为人工填写） */
  var F1 = [["UabKv", "AB线电压（kV）"], ["UbcKv", "BC线电压（kV）"], ["UcaKv", "CA线电压（kV）"], ["Ia", "A相电流（A）"], ["Ib", "B相电流（A）"], ["Ic", "C相电流（A）"]];
  var F2 = [["Pf", "功率因数"], ["S", "视在功率（kVA）"], ["P", "有功功率（kW）"], ["Q", "无功功率（kvar）"], ["F", "频率（Hz）"], ["RotateRate", "转速（RPM）"], ["OilPress", "机油压力（kPa）"], ["CoolantTemp", "冷却液温度（℃）"]];
  var CARD_F = [["WorkTime", "运行时间（h）"]].concat(F1, F2);
  /** 自动取数视图：15 个测点按两行排布（电气量 8 项 / 机组与功率 7 项），PC 端一屏看全，无需左右滑动 */
  var PTS = [
    [["UabKv", "AB线电压", "kV"], ["UbcKv", "BC线电压", "kV"], ["UcaKv", "CA线电压", "kV"], ["Ia", "A相电流", "A"], ["Ib", "B相电流", "A"], ["Ic", "C相电流", "A"], ["F", "频率", "Hz"], ["Pf", "功率因数", ""]],
    [["WorkTime", "运行时间", "h"], ["S", "视在功率", "kVA"], ["P", "有功功率", "kW"], ["Q", "无功功率", "kvar"], ["RotateRate", "转速", "RPM"], ["OilPress", "机油压力", "kPa"], ["CoolantTemp", "冷却液温度", "℃"]],
  ];
  var PT_GROUPS = [{ name: "电气量", icon: "ri-flashlight-line" }, { name: "机组 / 功率", icon: "ri-dashboard-3-line" }];
  var histOpen = {}; // 历史记录展开状态（按视图区分）：未设置时 PC 默认展开、手机默认收起

  function fmt(x) { return util.isEmpty(x) ? "—" : String(x); }
  function isMobile() { return !!(window.matchMedia && window.matchMedia("(max-width: 760px)").matches); }

  /** 自动取数记录：后端同时写入 form1 / form2（内容相同，旧版表单分两表展示），只读一份 */
  function rowsOf(o) {
    o = o || {};
    var r = o.form1;
    if (!Array.isArray(r) || !r.length) r = o.form2;
    return Array.isArray(r) ? r : [];
  }

  /** 最新一次数据看板：带单位与较上一次的升降趋势 */
  function latestBoard(rows) {
    var cur = rows[rows.length - 1], prev = rows[rows.length - 2];
    var trend = function (k) {
      if (!prev) return null;
      var a = parseFloat(cur[k]), b = parseFloat(prev[k]);
      if (isNaN(a) || isNaN(b) || a === b) return h("i", { class: "ri-subtract-line mw-dg-pt__tr is-flat", title: "与上次持平" });
      return h("i", { class: (a > b ? "ri-arrow-up-line is-up" : "ri-arrow-down-line is-down") + " mw-dg-pt__tr", title: "上次 " + prev[k] });
    };
    return h("div", { class: "mw-dg-board" },
      PTS.map(function (g, gi) {
        return h("div", { class: "mw-dg-board__grp" },
          h("h5", null, h("i", { class: PT_GROUPS[gi].icon }), PT_GROUPS[gi].name),
          h("div", { class: "mw-dg-board__grid" }, g.map(function (p) {
            return h("div", { class: "mw-dg-pt" },
              h("span", { class: "mw-dg-pt__n" }, p[1]),
              h("span", { class: "mw-dg-pt__v" }, h("b", null, fmt(cur[p[0]])), p[2] && h("small", null, p[2]), trend(p[0])));
          })));
      }));
  }

  /** 历史记录：每条记录占两行（与看板分组一致），PC 端表头对齐一屏看全，手机端单元格自带标签 */
  function historyGrid(rows, id) {
    var list = rows.slice().reverse();
    var cell = function (p, r) { return h("span", { class: "mw-dg-hist__c", dataset: { label: p[1] } }, fmt(r[p[0]])); };
    var line = function (g, r) { return h("div", { class: "mw-dg-hist__l" }, g.map(function (p) { return cell(p, r); }), g.length < 8 && h("span", { class: "mw-dg-hist__c is-pad" })); };
    return h("div", { class: "mw-dg-hist", dataset: { keepScroll: "hist-" + id } },
      h("div", { class: "mw-dg-hist__row is-head" },
        h("span", { class: "mw-dg-hist__t" }, "记录时间"),
        h("div", { class: "mw-dg-hist__ls" }, PTS.map(function (g) {
          return h("div", { class: "mw-dg-hist__l" }, g.map(function (p) {
            return h("span", { class: "mw-dg-hist__c" }, p[1], p[2] && h("small", null, p[2]));
          }), g.length < 8 && h("span", { class: "mw-dg-hist__c is-pad" }));
        }))),
      list.map(function (r, i) {
        return h("div", { class: ["mw-dg-hist__row", i === 0 && "is-latest"] },
          h("span", { class: "mw-dg-hist__t" }, h("b", null, r.log_time || "—"), i === 0 && h("em", null, "最新")),
          h("div", { class: "mw-dg-hist__ls" }, PTS.map(function (g) { return line(g, r); })));
      }));
  }

  /**
   * 自动取数视图：最新数据看板 + 可折叠的历史记录
   * rows 取数记录；id 区分多个视图（历史展开状态、内部滚动位置）；empty 无数据时的提示
   */
  function view(rows, id, empty) {
    id = id || "dg";
    if (!rows.length) return h("div", { class: "mw-dg-pv is-empty" }, h("div", { class: "mw-empty" }, h("i", { class: "ri-inbox-2-line" }), empty || "暂无数据，打开【获取数据】后自动刷新"));
    var open = histOpen[id] === undefined ? !isMobile() : histOpen[id];
    var last = rows[rows.length - 1];
    return h("div", { class: "mw-dg-pv" },
      h("div", { class: "mw-dg-pv__bar" },
        h("span", null, h("i", { class: "ri-time-line" }), "最近取数 ", h("b", null, last.log_time || "—")),
        h("span", null, h("i", { class: "ri-stack-line" }), "已记录 ", h("b", null, rows.length), " 条")),
      latestBoard(rows),
      rows.length > 1 && h("div", { class: ["mw-dg-pv__hist", open && "is-open"] },
        h("button", { type: "button", class: "mw-dg-pv__toggle", onClick: function () { histOpen[id] = !open; store.touch(); } },
          h("i", { class: "ri-history-line" }), h("span", null, "历史记录"), ui.tag(rows.length + " 条", "muted"),
          h("i", { class: "ri-arrow-down-s-line mw-dg-pv__arrow" })),
        open && historyGrid(rows, id)));
  }

  /**
   * 人工记录必填校验 -> [{key, msg}]
   * prefix 校验 key 前缀（如 "dg.370"），devices 非空时每条记录还需选择设备
   */
  function cardMissing(cs, prefix, devices) {
    var out = [];
    if (!cs.length) out.push({ key: prefix + ".card", msg: "请至少添加一条人工记录" });
    var fs = [["log_time", "记录时间"]].concat(CARD_F);
    if (devices && devices.length) fs = [["device_name", "设备名称"]].concat(fs);
    cs.forEach(function (c, i) {
      fs.forEach(function (f) {
        if (util.isEmpty(c[f[0]])) out.push({ key: prefix + ".card." + i + "." + f[0], msg: (f[0] === "device_name" ? "请选择" : "请填写") + f[1] });
      });
    });
    return out;
  }

  /**
   * 人工记录卡片（可添加 / 删除，每条 16 项必填）
   * o: rows, prefix（校验 key 前缀）, name（输入框 name 前缀）, disabled, err(suffix),
   *    set(list, typing) 保存整个列表, devices 设备名称列表（为空时显示 defaultName，不可选）, defaultName
   */
  function cards(o) {
    var cs = o.rows || [];
    var devices = o.devices || [];
    var dis = !!o.disabled;
    var setCard = function (i, f, val, typing) {
      var list = util.clone(cs);
      if (!list[i]) return;
      list[i][f] = val;
      o.set(list, typing);
    };
    var inp = function (c, i, f, label, type) {
      return ui.field({ label: label, required: true, key: o.prefix + ".card." + i + "." + f, error: o.err("card." + i + "." + f) },
        ui.input({ name: o.name + "_card_" + i + "_" + f, type: type || "text", inputmode: type ? null : "decimal", value: c[f], placeholder: type ? "" : "请输入", disabled: dis,
          onInput: function (val) { setCard(i, f, val, true); }, onBlur: function (val) { setCard(i, f, val); } }));
    };
    var devSel = function (c, i) {
      return ui.field({ label: "设备名称", required: true, key: o.prefix + ".card." + i + ".device_name", error: o.err("card." + i + ".device_name"), span: 2 },
        ui.select({ value: c.device_name, options: devices, disabled: dis, placeholder: "请选择设备", onChange: function (val) { setCard(i, "device_name", val); } }));
    };
    return h("div", { class: "mw-dg-cards", dataset: { key: o.prefix + ".card" } },
      cs.map(function (c, i) {
        var fields = [inp(c, i, "log_time", "记录时间", "time")].concat(CARD_F.map(function (f) { return inp(c, i, f[0], f[1]); }));
        if (devices.length) fields.unshift(devSel(c, i));
        return h("div", { class: "mw-dg-card", style: { animationDelay: Math.min(i, 6) * 30 + "ms" } },
          h("div", { class: "mw-dg-card__head" }, h("span", { class: "mw-sub__sn" }, "#" + (i + 1)), h("b", null, c.device_name || o.defaultName || "柴油发电机组"),
            ui.btn("删除", { type: "text-danger", icon: "ri-delete-bin-6-line", size: "sm", disabled: dis, onClick: function () {
              ui.confirm("确定删除第 " + (i + 1) + " 条记录吗？", { title: "删除记录" }).then(function () {
                var list = util.clone(o.rows || []);
                list.splice(i, 1);
                o.set(list);
              }).catch(function () {});
            } })),
          ui.grid(4, fields, "mw-dg-card__grid"));
      }),
      h("button", { type: "button", class: "mw-dg-add", disabled: dis, onClick: function () {
        var list = util.clone(cs);
        var prev = list[list.length - 1];
        var n = { device_name: devices.length ? (prev && prev.device_name) || (devices.length === 1 ? devices[0] : "") : o.defaultName || "", log_time: util.now().slice(11, 19) };
        CARD_F.forEach(function (f) { n[f[0]] = ""; });
        list.push(n);
        o.set(list);
      } }, h("i", { class: "ri-add-circle-line" }), "人工填写（点击添加新增）"),
      o.err("card") && h("div", { class: "mw-field__error" }, h("i", { class: "ri-error-warning-fill" }), o.err("card")));
  }

  MW.points = { F1: F1, F2: F2, CARD_F: CARD_F, PTS: PTS, rowsOf: rowsOf, view: view, cards: cards, cardMissing: cardMissing, fmt: fmt };
}
